// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import pageProfessionalKitData from './routes/exhibitRequest';
import pagePresentationRequestData from './routes/exhibitRequest';
import pageExhibitRequestData from './routes/exhibitRequest';
import pageInstallationTrainingRequestData from './routes/exhibitRequest';
import pageRequestForCaptelRepairsData from './routes/exhibitRequest';
/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,

  pageExhibitRequestData ,
  pageProfessionalKitData,
  pagePresentationRequestData,
  pageInstallationTrainingRequestData,
  pageRequestForCaptelRepairsData,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());


  // scroll top fixed header
  $(document).ready(function () {
    $(window).scroll(function () {
      if ($(this).scrollTop() > 100) {
        $('.nav-secondary').fadeIn();
        $('.nav-secondary').addClass('fixed-top');
      }
      else {
        $('.nav-secondary').removeClass('fixed-top');
      }
    });
    $('.nav-secondary').click(function () {
      $('html, body').animate({ scrollTop: 0 }, 100);
      return false;
    });
    $('.hamburger').click(function () {
      $('.secondary-nav').toggleClass('openmenu');
      $('body').toggleClass('menuopen');
    });
  });

    /*
   * jQuery jFontSize Plugin
   * Examples and documentation: http://jfontsize.com
   * Author: Frederico Soares Vanelli
   *         fredsvanelli@gmail.com
   *         http://twitter.com/fredvanelli
   *         http://facebook.com/fred.vanelli
   *
   * Copyright (c) 2011
   * Version: 1.0 (2011-07-15)
   * Dual licensed under the MIT and GPL licenses.
   * http://jfontsize.com/license
   * Requires: jQuery v1.2.6 or later
   */

  (function ($) {
    $.fn.jfontsize = function (opcoes) {
      var $this = $(this);
      var defaults = {
        btnMinusClasseId: '#jfontsize-minus',
        btnDefaultClasseId: '#jfontsize-default',
        btnPlusClasseId: '#jfontsize-plus',
        btnMinusMaxHits: 10,
        btnPlusMaxHits: 10,
        sizeChange: 1,
      };

      if (opcoes) {
        opcoes = $.extend(defaults, opcoes);
      }

      var limite = [];
      var fontsize_padrao = [];
      var fontsize;
      $(this).each(function (i) {
        limite[i] = 0;
        fontsize_padrao[i];
      });

      $(opcoes.btnMinusClasseId + ', ' + opcoes.btnDefaultClasseId + ', ' + opcoes.btnPlusClasseId).removeAttr('href');
      $(opcoes.btnMinusClasseId + ', ' + opcoes.btnDefaultClasseId + ', ' + opcoes.btnPlusClasseId).css('cursor', 'pointer');

      /* A��o do Bot�o A- */
      $(opcoes.btnMinusClasseId).click(function () {
        $(opcoes.btnPlusClasseId).removeClass('jfontsize-disabled');
        $this.each(function (i) {
          if (limite[i] > (-(opcoes.btnMinusMaxHits))) {
            fontsize_padrao[i] = $(this).css('font-size');
            fontsize_padrao[i] = fontsize_padrao[i].replace('px', '');
            fontsize = $(this).css('font-size');
            fontsize = parseInt(fontsize.replace('px', ''));
            fontsize = fontsize - (opcoes.sizeChange);
            fontsize_padrao[i] = fontsize_padrao[i] - (limite[i] * opcoes.sizeChange);
            limite[i]--;
            $(this).css('font-size', fontsize + 'px');
            if (limite[i] === (-(opcoes.btnMinusMaxHits))) {
              $(opcoes.btnMinusClasseId).addClass('jfontsize-disabled');
            }
          }
        });
      });

      /* A��o do Bot�o A */
      $(opcoes.btnDefaultClasseId).click(function () {
        $(opcoes.btnMinusClasseId).removeClass('jfontsize-disabled');
        $(opcoes.btnPlusClasseId).removeClass('jfontsize-disabled');
        $this.each(function (i) {
          limite[i] = 0;
          $(this).css('font-size', fontsize_padrao[i] + 'px');
        });
      });

      /* A��o do Bot�o A+ */
      $(opcoes.btnPlusClasseId).click(function () {
        $(opcoes.btnMinusClasseId).removeClass('jfontsize-disabled');
        $this.each(function (i) {
          if (limite[i] < opcoes.btnPlusMaxHits) {
            fontsize_padrao[i] = $(this).css('font-size');
            fontsize_padrao[i] = fontsize_padrao[i].replace('px', '');
            fontsize = $(this).css('font-size');
            fontsize = parseInt(fontsize.replace('px', ''));
            fontsize = fontsize + opcoes.sizeChange;
            fontsize_padrao[i] = fontsize_padrao[i] - (limite[i] * opcoes.sizeChange);
            limite[i]++;
            $(this).css('font-size', fontsize + 'px');
            if (limite[i] === opcoes.btnPlusMaxHits) {
              $(opcoes.btnPlusClasseId).addClass('jfontsize-disabled');
            }
          }
        });
      });
    };

    $('td,th,.font-size, p, a, li, h2, h5, h3, h4, p *, .banner-wrap .banner-container h2, h1,.content-with-image-component li, .content-block li, .services-list-wrap li, .wpcf7-form label, .wpcf7-list-item-label').jfontsize({
      btnMinusClasseId: '#jfontsize-m2', // Defines the class or id of the decrease button
      btnDefaultClasseId: '#jfontsize-d2', // Defines the class or id of default size button
      btnPlusClasseId: '#jfontsize-p2', // Defines the class or id of the increase button
      btnMinusMaxHits: 1, // How many times the size can be decreased
      btnPlusMaxHits: 3, // How many times the size can be increased
      sizeChange: 3, // Defines the range of change in pixels
    });
  })(jQuery);
  

  $(document).ready(function(){
    var session = sessionStorage.getItem('ThemeContrast');
    // Append the stylesheet on page load
    if (session === 'yellowThemeContrast') {
         $('body').addClass('yellow-theme');   
      $('body').removeClass('black-theme'); 
      $('body').removeClass('yellow-text-theme'); 
  
      $(this).addClass('active');   
      $('#blackTheme').removeClass('active'); 
      $('#yellowTextTheme').removeClass('active'); 
    }else if(session === 'blackTheme'){
        $('body').addClass('black-theme');   
      $('body').removeClass('yellow-theme'); 
      $('body').removeClass('yellow-text-theme'); 
  
      $(this).addClass('active'); 
      $('#yellowTheme').removeClass('active');
      $('#yellowTextTheme').removeClass('active');
    }  else if(session === 'yellowTextTheme'){
        $('body').addClass('yellow-text-theme');
      $('body').removeClass('black-theme');   
      $('body').removeClass('yellow-theme');
  
      $(this).addClass('active'); 
      $('#yellowTheme').removeClass('active');
      $('#blackTheme').removeClass('active'); 
    }  
    else{
         $('body').removeClass('yellow-theme');    
      $('body').removeClass('black-theme'); 
      $('body').removeClass('yellow-text-theme'); 
      
      $('#yellowTheme').removeClass('active');
      $('#blackTheme').removeClass('active'); 
      $('#yellowTextTheme').removeClass('active'); 
    }    
});



$(document).ready(function () {  
                   
    $('#blackTheme').click(function() {  
        sessionStorage.setItem('ThemeContrast','blackTheme');
      $('body').addClass('black-theme');   
      $('body').removeClass('yellow-theme'); 
      $('body').removeClass('yellow-text-theme'); 
  
      $(this).addClass('active'); 
      $('#yellowTheme').removeClass('active');
      $('#yellowTextTheme').removeClass('active');
    });
  
   $('#yellowTextTheme').click(function() { 
       sessionStorage.setItem('ThemeContrast','yellowTextTheme');
       
    $('body').addClass('yellow-text-theme');
      $('body').removeClass('black-theme');   
      $('body').removeClass('yellow-theme');
  
      $(this).addClass('active'); 
      $('#yellowTheme').removeClass('active');
      $('#blackTheme').removeClass('active'); 
    });
    
    $('#yellowTheme').click(function() {  
        sessionStorage.setItem('ThemeContrast','yellowThemeContrast');
        
      $('body').addClass('yellow-theme');   
      $('body').removeClass('black-theme'); 
      $('body').removeClass('yellow-text-theme'); 
  
      $(this).addClass('active');   
      $('#blackTheme').removeClass('active'); 
      $('#yellowTextTheme').removeClass('active');    
    });
  
    $('#resetTheme').click(function() { 
        sessionStorage.setItem('ThemeContrast','reset');
      $('body').removeClass('yellow-theme');    
      $('body').removeClass('black-theme'); 
      $('body').removeClass('yellow-text-theme'); 
      
      $('#yellowTheme').removeClass('active');
      $('#blackTheme').removeClass('active'); 
      $('#yellowTextTheme').removeClass('active');           
    });
  });
 




// WEBPACK FOOTER //
// ./scripts/main.js